export default "__VITE_ASSET__CoA2keSX__"